export function preventInspection() {
  if (import.meta.env.DEV) {
    return;
  }

  window.addEventListener("resize", () => {
    console.log("resize");
    // eslint-disable-next-line no-debugger
    debugger;
  });

  // Prevent keyboard shortcuts
  window.addEventListener("keydown", (event) => {
    // F12
    if (event.key === "F12") {
      // eslint-disable-next-line no-debugger
      debugger;
    }
    // Ctrl+Shift+I
    if (event.ctrlKey && event.shiftKey && event.key === "I") {
      // eslint-disable-next-line no-debugger
      debugger;
    }
    // Ctrl+Shift+J
    if (event.ctrlKey && event.shiftKey && event.key === "J") {
      // eslint-disable-next-line no-debugger
      debugger;
    }
    // Ctrl+Shift+C
    if (event.ctrlKey && event.shiftKey && event.key === "C") {
      // eslint-disable-next-line no-debugger
      debugger;
    }
  });
}
